module.exports = __webpack_public_path__ + "img/prev-expo.ec14de82.svg";